<template>
	<div class="rules-info">
		<div class="rules-info__content">
			{{ highlightRulesText }}
			<Icon
				v-tooltip="{
					content: highlightRulesInfo,
					classes: 'tooltip',
					container: $root.$el,
				}"
				class="rules-info__icon"
				icon-name="c-info"
				inline
				size="sm"
			/>
			<div class="rules-info__list-w s-html -sm">
				<ul class="rules-info__list">
					<li
						v-for="(rule, i) in highlightRules"
						:key="i"
					>
						<a
							class="rules-info__link"
							:href="highlightRulesLink"
							target="_blank"
						>{{ rule.name }}</a>
					</li>
				</ul>
			</div>
		</div>
		<Icon
			class="rules-info__exit"
			icon-name="e-remove"
			@click="() => $emit('close')"
		/>
	</div>
</template>

<script>
import laroute from '@laroute';

export default {
	name:  'HighlightRulesInfo',
	props: {
		highlightRules: {
			type:    Array,
			default: () => [],
		},
	},
	computed: {
		highlightRulesLink() {
			return laroute.route('manager.events.highlight_rules');
		},
		highlightRulesText() {
			return this.trans('one.tag_center_rule_active');
		},
		highlightRulesInfo() {
			return this.trans('one.tag_center_rule_info');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.rules-info {
	display: flex;
	justify-content: space-between;
	padding: 16px 24px;
	color: var(--color-black);
	background: var(--color-hype-yellow);
}

.rules-info__exit {
	cursor: pointer;
}

.rules-info__icon {
	position: relative;
	top: $sp1;
}

.rules-info__list {
	margin-bottom: 0;
	color: var(--color-black);
}

.rules-info__link {
	color: var(--color-black);
	text-decoration: underline;

	&:hover {
		color: var(--color-grey-700) !important; // stylelint-disable-line
	}
}
</style>
